<template>
  <BaseShimmer
    class="cr-w-100 cr-br-round"
    height="36px"
  />
  <div class="cr-overflow-auto">
    <div
      v-for="n in numThreadGroups"
      :key="n"
      class="cr-flex cr-flex-col spc-pt-2 gap-2"
    >
      <BaseShimmer
        height="14px"
        width="53px"
      />
      <BaseShimmer
        v-for="i in getRandomIntInRange(minNumThreadsPerGroup, maxNumThreadsPerGroup)"
        :key="i"
        class="spc-ml-3"
        height="18px"
        :width="`${120 + getRandomIntInRange(1, 160)}px`"
      />
    </div>
  </div>
</template>

<script>
import BaseShimmer from './BaseShimmer.vue'
import { randomInRange } from '../utils'

export default {
  name: 'CraftyCopilotHistoryLoading',
  components: {
    BaseShimmer,
  },
  props: {
    numThreadGroups: {
      type: Number,
      default: 4,
    },
    minNumThreadsPerGroup: {
      type: Number,
      default: 2,
    },
    maxNumThreadsPerGroup: {
      type: Number,
      default: 7,
    },
  },
  methods: {
    getRandomIntInRange(min, max) {
      return Math.ceil(randomInRange(min, max))
    },
  },
}
</script>

<style lang="scss" scoped>
.base-shimmer.cr-br-round {
  &::after {
    border-radius: var(--cr-br-round);
  }
}
</style>
